"use strict";

// ITU normalization for Germany, as it is missing in Google libphonenumber at this moment
// github issue: griffin-paypal/#1077
function adjustPhoneNumberITU(phone, regionCode) {
  if (phone === undefined || phone === null || regionCode !== "DE") {
    return phone;
  }
  var trimmedPhone = phone.trim();
  if (
    trimmedPhone &&
    trimmedPhone.length > 11 &&
    trimmedPhone.substring(0, 2) === "49"
  ) {
    phone = trimmedPhone.substring(2);
  }
  return phone;
}

module.exports = {
  adjustPhoneNumberITU: adjustPhoneNumberITU
};



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/griffin-paypal/lib/client/utils/phoneHelpers.js
// module id = 189
// module chunks = 5 6 7 8 9 10 11